import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const Content = styled.div`
  h1 {
    font-size: 24px;
    padding-bottom: 20px;
  }
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 14px;
  }
  h4 {
    font-size: 12px;
  }
  h5 {
    font-size: 12px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Roboto Slab', serif;
    font-weight: 700;
    -webkit-font-smoothing: antialiased;
    -webkit-text-shadow: rgba(0, 0, 0, 0.01) 0 0 1px;
    text-shadow: rgba(0, 0, 0, 0.01) 0 0 1px;
    color: ${props => props.theme.colors.greyDark};
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .subtitle {
    font-size: 24px;
    color: ${props => props.theme.colors.greyDark};
    margin-top: 9px;
  }
  li {
    position: relative;
    padding-left: 27px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.75;
    color: #76777a;
  }
  li:not(:last-child) {
    margin-bottom: 2px;
  }
  li::before {
    display: block;
    position: absolute;
    top: 9px;
    left: 1px;
    width: 7px;
    height: 7px;
    background: ${props => props.theme.colors.textDark};
    content: '';
    border-radius: 50%;
  }
`

const SidebarText = ({ input }) => <Content dangerouslySetInnerHTML={{ __html: input.primary.content.html }} />

export default SidebarText

SidebarText.propTypes = {
  input: PropTypes.object.isRequired,
}
